import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import EmployeeRegistration from '../components/EmployeeRegistration';
import { Employee } from '../types';

const EmployeeRegistrationPage: React.FC = () => {
  const handleRegistrationComplete = (employee: Employee) => {
    console.log('Employee registered successfully:', employee);
    // You can add additional logic here, such as redirecting to login page
    // or showing a success message
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Join Our Team
        </Typography>
        <Typography variant="h6" component="p" gutterBottom align="center" color="text.secondary" sx={{ mb: 4 }}>
          Create your employee account to access the payroll system
        </Typography>
        
        <EmployeeRegistration onRegistrationComplete={handleRegistrationComplete} />
        
        <Paper sx={{ mt: 4, p: 3, textAlign: 'center', bgcolor: 'background.default' }}>
          <Typography variant="body2" color="text.secondary">
            Already have an account?{' '}
            <a href="/login" style={{ color: 'inherit', textDecoration: 'underline' }}>
              Sign in here
            </a>
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default EmployeeRegistrationPage;